import { setGlobal } from "../../store/globalcontents.store";
import catchAsync from "../../utils/catchAsync";
import httpsCall from "../httpsCall";

export const globalContentsApi = catchAsync(async (dispatch) => {
    // Make the API call
    const { data } = await httpsCall.get(`gensett/getsettings`);
    const { _id, createdAt,__v, updatedAt, ...cleanedData } = data.settings;
    dispatch(setGlobal(cleanedData))
    //console.log(data);
    return data;
});
